// extracted by mini-css-extract-plugin
export default {"root":"U7QB6t9pT9","buttonContainer":"ZAXtoxXlbQ"};